module.exports = __webpack_public_path__ + "img/sleeve ruffle length.bc90aa1b.png";